export { default as CoreUserInfoStore } from './CoreUserInfoStore';



// WEBPACK FOOTER //
// ./src/modules/core-user-info/stores/index.js